import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList'; // ВАЖНО: Добавить импорт

// Кнопки
import Button from 'flarum/common/components/Button';

// Модалки
import LogInModal from 'flarum/forum/components/LogInModal';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import ForgotPasswordModal from 'flarum/forum/components/ForgotPasswordModal';
import ChangePasswordModal from 'flarum/forum/components/ChangePasswordModal';
import ChangeEmailModal from 'flarum/forum/components/ChangeEmailModal';

// Дропдаун сессии (меню пользователя)
import SessionDropdown from 'flarum/forum/components/SessionDropdown';

// Страница настроек
import SettingsPage from 'flarum/forum/components/SettingsPage';

// Уведомления
import NotificationGrid from 'flarum/forum/components/NotificationGrid';

// Аватар
import AvatarEditor from 'flarum/forum/components/AvatarEditor';

// Дополнительно для отображения уровня и иконок
import PostUser from 'flarum/forum/components/PostUser';
import UserCard from 'flarum/forum/components/UserCard';

app.initializers.add('rebk-sso-forum', () => {

    /**
     * Проверяет может ли пользователь модерировать
     * (админы и модераторы)
     */
    function canModerate(user) {
        if (!user) return false;

        // Проверяем является ли пользователем админом
        if (user.data.attributes.isAdmin) {
            return true;
        }

        // Проверяем наличие группы модераторов (ID = 4)
        const groups = user.data.relationships?.groups?.data || [];
        const isModerator = groups.some(group => group.id === '4');

        return isModerator;
    }

    // Проверка что username это число (строка с числом или число)
    function isNumericUsername(username) {
        return username && /^\d+$/.test(String(username));
    }

    // 1. Модифицируем отображение имени в постах
    extend(PostUser.prototype, 'view', function(vnode) {
        const user = this.attrs.post.user();
        if (!user) return;

        const level = user.data?.attributes?.level;
        const userId = user.username();
        const baseUrl = app.forum.attribute('rebkSsoInfoBase');

        // Добавляем уровень
        if (level && level > 0) {
            if (vnode.children && vnode.children.length > 0) {
                vnode.children.push(
                    m('span.user-level-badge', {
                        style: 'margin-left: 5px; color: #888; font-weight: normal;'
                    }, `[${level}]`)
                );
            }
        }

        // Добавляем инфо-ссылку только если username - это число
        if (baseUrl && userId && isNumericUsername(userId)) {
            vnode.children.push(
                m('a.user-info-link', {
                    href: `${baseUrl}/inf.php?${userId}`,
                    target: '_blank',
                    title: 'Инфо о персонаже',
                    style: 'margin-left: 8px; color: #3498db; text-decoration: none; font-size: 0.9em;',
                    onclick: (e) => e.stopPropagation()
                }, '[i]')
            );
        }
    });

    // 2. Модифицируем карточку профиля
    extend(UserCard.prototype, 'infoItems', function(items) {
        const user = this.attrs.user;
        if (!user) return;

        const level = user.data?.attributes?.level;
        const userId = user.username();
        const baseUrl = app.forum.attribute('rebkSsoInfoBase');

        // Показываем уровень - в карточке не нужен
        // if (level && level > 0) {
        //   items.add(
        //     'user-level',
        //     m('div.user-level-info', { style: 'margin: 10px 0; padding: 8px; background: #f8f9fa; border-radius: 4px;' }, [
        //       m('strong', 'Уровень: '),
        //       m('span.badge', { style: 'background: #3498db; color: white; padding: 2px 8px; border-radius: 3px; margin-left: 5px;' }, level)
        //     ]),
        //     100
        //   );
        // }

        // Показываем инфо-кнопку только если username - это число
        if (baseUrl && userId && isNumericUsername(userId)) {
            items.add(
                'user-external-info',
                m('a.Button.Button--block', {
                    href: `${baseUrl}/inf.php?${userId}`,
                    target: '_blank',
                    style: 'margin-top: 10px; background: #3498db; color: white;'
                }, [
                    m('i.fas.fa-info-circle', { style: 'margin-right: 5px;' }),
                    'Инфо о персонаже'
                ]),
                90
            );
        }
    });

    // ============================================================
    // 1. ЗАМЕНЯЕМ МОДАЛКУ ЛОГИНА НА РЕДИРЕКТ
    // ============================================================

    override(LogInModal.prototype, 'view', function() {
        const externalLoginUrl = app.forum.attribute('rebkSsoInfoBase') || window.location.origin;

        return m('.Modal.Modal--small', [
            m('.Modal-content', [
                m('.Modal-header', [
                    m('h3.App-titleControl.App-titleControl--text', 'Вход в систему')
                ]),
                m('.Modal-body', [
                    m('p', 'Для входа на форум используйте учётную запись основного сайта.'),
                    m('.Form-group', [
                        Button.component({
                            className: 'Button Button--primary Button--block',
                            onclick: () => {
                                window.location.href = externalLoginUrl;
                            }
                        }, 'Перейти на страницу входа')
                    ]),
                    m('p.helpText', [
                        'Если у вас нет аккаунта, ',
                        m('a', {
                            href: externalLoginUrl + '/register.php',
                            target: '_blank',
                            rel: 'noopener'
                        }, 'зарегистрируйтесь'),
                        ' на основном сайте.'
                    ]),
                    m('.Form-group', [
                        Button.component({
                            className: 'Button Button--primary Button--block',
                            onclick: () => app.modal.close()
                        }, 'Вернуться на форум')
                    ])
                ])
            ])
        ]);
    });

    // ============================================================
    // 2. БЛОКИРУЕМ МОДАЛКУ РЕГИСТРАЦИИ
    // ============================================================

    override(SignUpModal.prototype, 'view', function() {
        const externalLoginUrl = app.forum.attribute('rebkSsoInfoBase') || window.location.origin;

        return m('.Modal.Modal--small', [
            m('.Modal-content', [
                m('.Modal-header', [
                    m('h3.App-titleControl.App-titleControl--text', 'Регистрация')
                ]),
                m('.Modal-body', [
                    m('p', 'Регистрация производится на основном сайте.'),
                    m('.Form-group', [
                        Button.component({
                            className: 'Button Button--primary Button--block',
                            onclick: () => {
                                window.location.href = externalLoginUrl + '/register';
                            }
                        }, 'Перейти на страницу регистрации')
                    ]),
                    m('.Form-group', [
                        Button.component({
                            className: 'Button Button--primary Button--block',
                            onclick: () => app.modal.close()
                        }, 'Вернуться на форум')
                    ])
                ])
            ])
        ]);
    });

    // ============================================================
    // 3. БЛОКИРУЕМ ВОССТАНОВЛЕНИЕ ПАРОЛЯ
    // ============================================================

    override(ForgotPasswordModal.prototype, 'view', function() {
        const externalLoginUrl = app.forum.attribute('rebkSsoInfoBase') || window.location.origin;

        return m('.Modal.Modal--small', [
            m('.Modal-content', [
                m('.Modal-header', [
                    m('h3.App-titleControl.App-titleControl--text', 'Восстановление пароля')
                ]),
                m('.Modal-body', [
                    m('p', 'Восстановление пароля производится на основном сайте.'),
                    m('.Form-group', [
                        Button.component({
                            className: 'Button Button--primary Button--block',
                            onclick: () => {
                                window.location.href = externalLoginUrl + '/forgot-password';
                            }
                        }, 'Перейти на страницу восстановления')
                    ]),
                    m('.Form-group', [
                        Button.component({
                            className: 'Button Button--primary Button--block',
                            onclick: () => app.modal.close()
                        }, 'Вернуться на форум')
                    ])
                ])
            ])
        ]);
    });

    // ============================================================
    // 4. МОДИФИЦИРУЕМ КНОПКУ ВЫХОДА - УДАЛЯЕМ КУКУ
    // ============================================================

    extend(SessionDropdown.prototype, 'items', function(items) {
        const logOutItem = items.get('logOut');

        if (logOutItem && logOutItem.attrs) {
            const originalOnclick = logOutItem.attrs.onclick;

            logOutItem.attrs.onclick = function(e) {
                // Получаем домен из настроек или используем текущий
                const cookieDomain = app.forum.attribute('rebkSsoCookieDomain') || window.location.hostname;

                // Удаляем JWT куки
                document.cookie = `forum_token=; Max-Age=0; Path=/; Domain=${cookieDomain}`;
                document.cookie = `forum_token_force_refresh=; Max-Age=0; Path=/; Domain=${cookieDomain}`;

                // Вызываем оригинальный обработчик (выход из Flarum)
                if (originalOnclick) {
                    originalOnclick.call(this, e);
                }
            };
        }
    });

    // ============================================================
    // 5. УБИРАЕМ БЛОК "АККАУНТ" ИЗ НАСТРОЕК
    // ============================================================

    // Удаляем элементы из секции Account
    extend(SettingsPage.prototype, 'accountItems', function(items) {
        items.remove('changePassword');
        items.remove('changeEmail');
    });

    // Удаляем всю секцию Account (так как она пустая)
    extend(SettingsPage.prototype, 'settingsItems', function(items) {
        items.remove('account');
    });

    // ============================================================
    // 6. БЛОКИРУЕМ ПРЯМЫЕ ВЫЗОВЫ МОДАЛОК СМЕНЫ ПАРОЛЯ/EMAIL
    // ============================================================

    override(ChangePasswordModal.prototype, 'view', function() {
        const externalLoginUrl = app.forum.attribute('rebkSsoInfoBase') || window.location.origin;

        return m('.Modal.Modal--small', [
            m('.Modal-content', [
                m('.Modal-header', [
                    m('h3', 'Смена пароля недоступна')
                ]),
                m('.Modal-body', [
                    m('p', 'Управление паролем производится на основном сайте.'),
                    m('.Form-group', [
                        Button.component({
                            className: 'Button Button--primary Button--block',
                            onclick: () => {
                                window.location.href = externalLoginUrl + '/settings';
                            }
                        }, 'Перейти в настройки аккаунта')
                    ]),
                    m('.Form-group', [
                        Button.component({
                            className: 'Button Button--primary Button--block',
                            onclick: () => app.modal.close()
                        }, 'Вернуться на форум')
                    ])
                ])
            ])
        ]);
    });

    override(ChangeEmailModal.prototype, 'view', function() {
        const externalLoginUrl = app.forum.attribute('rebkSsoInfoBase') || window.location.origin;

        return m('.Modal.Modal--small', [
            m('.Modal-content', [
                m('.Modal-header', [
                    m('h3', 'Смена email недоступна')
                ]),
                m('.Modal-body', [
                    m('p', 'Управление email производится на основном сайте.'),
                    m('.Form-group', [
                        Button.component({
                            className: 'Button Button--primary Button--block',
                            onclick: () => {
                                window.location.href = externalLoginUrl + '/settings';
                            }
                        }, 'Перейти в настройки аккаунта')
                    ]),
                    m('.Form-group', [
                        Button.component({
                            className: 'Button Button--primary Button--block',
                            onclick: () => app.modal.close()
                        }, 'Вернуться на форум')
                    ])
                ])
            ])
        ]);
    });

    // ============================================================
    // 7. ДОБАВЛЯЕМ ИНФОРМАЦИЮ В НАСТРОЙКАХ
    // ============================================================

    extend(SettingsPage.prototype, 'settingsItems', function(items) {
        const externalLoginUrl = app.forum.attribute('rebkSsoInfoBase') || window.location.origin;

        items.add('sso-notice',
            m('.Settings-info.Alert', [
                m('strong', 'Управление аккаунтом: '),
                m('span', 'Изменение пароля, email и других данных учётной записи производится на '),
                m('a', {
                    href: externalLoginUrl + '/settings',
                    target: '_blank',
                    rel: 'noopener'
                }, 'основном сайте'),
                m('span', '.')
            ]),
            -100
        );
    });

    // ============================================================
    // 8. СКРЫВАЕМ EMAIL УВЕДОМЛЕНИЯ ДЛЯ НЕ-АДМИНОВ
    // ============================================================

    extend(NotificationGrid.prototype, 'columns', function(columns) {
        const user = app.session.user;

        if (!user) return;

        // Только админы могут видеть email колонку
        const isAdmin = user.data.attributes.isAdmin;

        if (!isAdmin) {
            // Находим и удаляем email колонку
            const emailIndex = columns.findIndex(col => col.name === 'email');
            if (emailIndex !== -1) {
                columns.splice(emailIndex, 1);
            }
        }
    });

    // Добавляем CSS класс для дополнительного скрытия
    extend(NotificationGrid.prototype, 'oncreate', function(vnode) {
        const user = app.session.user;
        if (!user) return;

        const isAdmin = user.data.attributes.isAdmin;

        if (!isAdmin) {
            // Добавляем класс к DOM элементу
            if (this.element) {
                this.element.classList.add('hide-email-notifications');
            }
        }
    });

    // ============================================================
    // 9. СКРЫВАЕМ ЗАГРУЗКУ АВАТАРОВ ДЛЯ ОБЫЧНЫХ ПОЛЬЗОВАТЕЛЕЙ
    // ============================================================

    // Блокируем controlItems (кнопки загрузки/удаления) для обычных пользователей
    override(AvatarEditor.prototype, 'controlItems', function(original) {
        const user = app.session.user;

        // Если нет залогиненного пользователя - скрываем
        if (!user) {
            return new ItemList();
        }

        // Админы и модераторы видят все кнопки
        if (canModerate(user)) {
            return original();
        }

        // Обычным пользователям скрываем кнопки
        return new ItemList();
    });

    // Дополнительно: добавляем CSS класс для надёжности
    extend(AvatarEditor.prototype, 'oncreate', function(vnode) {
        const user = app.session.user;

        if (user && !canModerate(user)) {
            // Добавляем класс для скрытия через CSS
            if (this.element) {
                this.element.classList.add('hide-avatar-controls');
            }
        }
    });

    // console.log('rebk-sso extension loaded');
});
